import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'exclude',
  standalone: true,
})
export class ExcludePipe implements PipeTransform {
  transform(array: unknown[], valueToExclude: unknown, key?: string): unknown[] {
    if (!Array.isArray(array)) {
      return array;
    }

    // filtering for primitive types (string, number)
    if (!key) {
      return array.filter(item => item !== valueToExclude);
    }

    // filtering for objects by key
    return array.filter(item => {
      if (item && typeof item === 'object' && key in item) {
        return item[key] !== valueToExclude;
      }
      return true;
    });
  }
}
